import { useState } from 'react';

// ============================================================
// Bloc « Avant / Après » : comparateur d'images avec curseur.
// L'image « avant » est révélée par-dessus l'image « après ».
// ============================================================

interface Props {
  imageBefore: string;
  imageAfter: string;
  labelBefore: string;
  labelAfter: string;
}

export default function BeforeAfterBlock({ imageBefore, imageAfter, labelBefore, labelAfter }: Props) {
  const [pos, setPos] = useState(50);

  if (!imageBefore && !imageAfter) {
    return (
      <div className="flex h-56 w-full items-center justify-center rounded-lg border border-background-200/70 bg-background-100 text-foreground-300">
        <i className="ri-contrast-drop-2-line text-3xl"></i>
      </div>
    );
  }

  return (
    <div className="w-full">
      <div className="relative w-full select-none overflow-hidden rounded-lg border border-background-200/70" style={{ aspectRatio: '16 / 9' }}>
        {imageAfter ? (
          <img src={imageAfter} alt={labelAfter} className="absolute inset-0 h-full w-full object-cover object-top" />
        ) : null}
        {imageBefore ? (
          <img
            src={imageBefore}
            alt={labelBefore}
            className="absolute inset-0 h-full w-full object-cover object-top"
            style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}
          />
        ) : null}

        <span className="absolute left-3 top-3 rounded-full bg-foreground-950/70 px-3 py-1 text-[11px] font-semibold text-background-50">
          {labelBefore || 'Avant'}
        </span>
        <span className="absolute right-3 top-3 rounded-full bg-primary-500 px-3 py-1 text-[11px] font-semibold text-background-50 dark:text-foreground-950">
          {labelAfter || 'Après'}
        </span>

        <div
          className="pointer-events-none absolute inset-y-0 w-0.5 bg-background-50"
          style={{ left: `${pos}%` }}
        >
          <span className="absolute left-1/2 top-1/2 flex h-9 w-9 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-background-50 text-foreground-900">
            <i className="ri-drag-move-2-line text-base"></i>
          </span>
        </div>
      </div>

      <input
        type="range"
        min={0}
        max={100}
        value={pos}
        onChange={(e) => setPos(Number(e.target.value))}
        aria-label="Comparer avant et après"
        className="mt-4 w-full cursor-pointer accent-primary-500"
      />
    </div>
  );
}